import script from "./UserHeadTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserHeadTop.vue?vue&type=script&lang=ts&setup=true"

import "./UserHeadTop.vue?vue&type=style&index=0&id=67e089d6&lang=css"

const __exports__ = script;

export default __exports__